import React from "react";
import { Spin } from "antd";

const EmptyAnal = ({ isIndex, text }) => {
  return (
    <div className='w-full h-full flex justify-center items-center'>
      <div className='flex flex-col justify-center items-center h-24'>
        {isIndex ? (
          <>
            <svg
              className='w-16 mb-3 text-blue-400'
              fill='currentColor'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z' />
              <path d='M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z' />
            </svg>
            <p className='p-0 m-0 text-blue-400 font-bold text-center'>
              {text}
            </p>
          </>
        ) : (
          <Spin size='large' />
        )}
      </div>
    </div>
  );
};

export default EmptyAnal;
